import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { appendAlertItem, AlertType } from 'src/redux/common/commonSlice';
import { takeUIScreenViewEvent } from 'src/app/common/ga/ga';
import { eventDetailRegFormGAData } from 'src/app/common/ga/types/ga-event';
import { StepStatusEnum, ComponentProps } from 'src/app/common/components/pru-stepped-form-agent';
import { EventFormCommonProps } from 'src/app/modules/event-v2/types';
import { CreateUpdateEventBody, modifyEventItem } from 'src/app/modules/event-v2/network';

type HookProps = ComponentProps<EventFormCommonProps>;

export const useRegistrationForm = ({ formCommonProps, onStepChange }: HookProps) => {
  const dispatch = useDispatch();
  const { eventItem, walkInAllowed, reloadData } = formCommonProps;
  const regFormRef = useRef<any>();

  useEffect(() => {
    takeUIScreenViewEvent(eventDetailRegFormGAData);
  }, []);

  const handleSave = async () => {
    if (regFormRef.current) {
      regFormRef.current?.handleSave();
    }
  };

  const onSubmit = async (data: any) => {
    const body: CreateUpdateEventBody = {
      regFormBody: data.content,
    };
    try {
      if (eventItem) {
        await modifyEventItem(eventItem._id, body, dispatch);
        await reloadData();
        dispatch(
          appendAlertItem([
            {
              severity: AlertType.SUCCESS,
              title: 'Success',
              content: 'Data saved successfully',
            },
          ]),
        );
        // Go to Publish Setting
        let newStepIndex = 5;
        if (walkInAllowed) {
          // Go to Walk-in Form
          newStepIndex = 4;
        }
        onStepChange({
          newActiveStep: { stepIndex: newStepIndex },
          currentStepStatus: StepStatusEnum.FINISHED,
          forceNavigation: true,
          saveChanges: true,
        });
      }
    } catch (err) {}
  };

  return {
    regFormRef,
    handleSave,
    onSubmit,
  };
};
